import React from 'react'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import ActionDialog from '../action-dialog'
import * as S from './styled'
import { withI18n } from '../../hocs'

// Ficha a pantalla casi completa: sin título ni botones, el contenido trae su propio "volver"
const ModalView = ({ open, handleClose, children }) => {
  return (
    <ActionDialog
      open={!!open}
      onClose={handleClose}
      showActions={false}
      maxWidth={false}
      contentStyle={S.contentStyle}
    >
      {children && React.cloneElement(children, { onGoBack: handleClose })}
    </ActionDialog>
  )
}

ModalView.propTypes = {
  open: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
}

ModalView.defaultProps = {
  filtersValues: {},
  filterName: '',
  children: <></>,
  title: ''
}

const enharce = compose(withI18n)

export default enharce(ModalView)
